/**
 * @Description 点位和围栏的入口文件，这个文件主要负责控制显示、隐藏逻辑
 */
import { DISTRICT_LEVEL } from '@/common/components/AMap/ts-config';
import { isEqual } from '@lhb/func';
import { FC, useEffect, useRef, useState } from 'react';
import useLatest from '@/common/hook/useLatest';
import MarkerCon from './MarkerCon';
import { useSatellite } from '@/common/hook/Amap/useSatellite';
// import { polygonZIndex } from './BorderMarker';

const Point: FC<{
  mapIns,
  pointData,
  level,
  itemData,
  setItemData,
  locationInfo,
  polygonData,
  allPointData,
  isShape,
  polygonListRef,
  isShowClusterMarkerOfDistrict,
  curZoom, // 当前地图缩放级别
  isBatchCollect, // 是否是批量收藏状态收藏
  batchCollectIds, // 批量收藏的开店区域id
  setBatchCollectIds, // 设置批量收藏的开店区域id
  viewAreaData, // 可视区域内的开店区域数据
  cityProvinceInfo, // 左上角城市信息
}> = ({
  mapIns,
  pointData,
  level,
  itemData,
  setItemData,
  locationInfo,
  polygonData,
  allPointData,
  isShape,
  polygonListRef,
  isShowClusterMarkerOfDistrict,
  curZoom, // 当前地图缩放级别
  isBatchCollect, // 是否是批量收藏状态收藏
  batchCollectIds, // 批量收藏的开店区域id
  setBatchCollectIds, // 设置批量收藏的开店区域id
  viewAreaData, // 可视区域内的开店区域数据
  cityProvinceInfo, // 左上角城市信息
}) => {
  const [newPointData, setNewPointData] = useState<any[]>([]);// 新增的点位数据
  const [newPolygonData, setNewPolygonData] = useState<any[]>([]);// 新增的围栏数据
  const pointListRef = useRef<any[]>([]);// 开店区域点位marker
  const curSelectRef = useRef<any>(null);// 当前选中的开店区域点位marker和围栏polygon
  const hasClickRef = useRef<boolean>(false);// 由于点位marker直接绑定了点击事件，而地图页绑定了点击事件，所以会触发两次，这里用来控制
  const targetZoomNamesMarkerRef = useRef<any[]>([]); // 指定缩放区域时显示的所有的name的覆盖物
  const isSatellite = useSatellite();// 是否正在使用卫星地图
  // const isSatelliteRef = useLatest(isSatellite);
  const allPointDataRef = useLatest<any[]>(allPointData);// 所有的点位数据
  const isShapeRef = useLatest<any>(isShape);// 是否选中”绘制“商圈

  // 绘制开店区域
  const createPoint = () => {
    const newAddData: any = [];// 需要新加的数据
    const equalData: any = [];// 相同的数据id

    // 获取要新增的数据和相同的数据id
    pointData.map((item) => {
      let isEqualFlag = false;
      pointListRef.current?.forEach((marker) => {
        if (marker.getExtData()?.id === item?.id) {
          // 和旧数据完全相同
          if (isEqual(marker.getExtData(), item)) {
            equalData.push(item.id);
            isEqualFlag = true;
          }
        }
      });
      // 需要新增的数据
      if (!isEqualFlag) {
        newAddData.push(item);
      }
    });
    const newAddressMarker: any = [];
    // 移出不包括的旧数据
    pointListRef.current?.map((marker) => {
      marker.show();// 这段代码用于新增商圈后addressMarker的显示
      if (!equalData.includes(marker.getExtData()?.id)) {
        marker.remove();
      } else {
        newAddressMarker.push(marker);
      }
    });
    pointListRef.current = newAddressMarker;
    setNewPointData(newAddData);
  };

  // 绘制商圈
  const createPolygon = () => {
    const newAddData: any = [];// 需要新加的数据
    const equalData: any = [];// 相同的数据id
    // 获取要新增的数据和相同的数据id
    polygonData.map((item) => {
      let isEqualFlag = false;
      polygonListRef.current?.forEach((marker) => {
        if (marker.getExtData()?.id === item?.id) {
          // 和旧数据完全相同
          if (isEqual(marker.getExtData(), item)) {
            equalData.push(item.id);
            isEqualFlag = true;
          }
        }
      });
      // 需要新增的数据
      if (!isEqualFlag) {
        newAddData.push(item);
      }
    });
    const newAddressMarker: any = [];
    // 移出不包括的旧数据
    polygonListRef.current?.map((marker) => {
      marker.show();// 这段代码用于新增商圈后addressMarker的显示
      if (!equalData.includes(marker.getExtData()?.id)) {
        marker.remove();
      } else {
        newAddressMarker.push(marker);
      }
    });
    polygonListRef.current = newAddressMarker;
    setNewPolygonData(newAddData);
  };

  // 清空点位
  const clearPoint = () => {
    pointListRef.current?.map((marker) => {
      mapIns.remove(marker);
    });
    pointListRef.current = [];
  };
  // 清空围栏
  const clearPolygon = () => {
    polygonListRef.current?.map((marker) => {
      mapIns.remove(marker);
    });
    polygonListRef.current = [];
  };

  // 绘制点位
  useEffect(() => {
    if (!mapIns) return;
    if (isShowClusterMarkerOfDistrict) return;
    createPoint();
  }, [mapIns, isShowClusterMarkerOfDistrict, pointData]);

  // 绘制围栏
  useEffect(() => {
    if (!mapIns) return;
    // 如果显示点聚合，那么清空围栏
    if (isShowClusterMarkerOfDistrict || polygonData.length > 500) {
      clearPolygon();
      return;
    }
    createPolygon();
  }, [mapIns, polygonData, isShowClusterMarkerOfDistrict]);

  // 清空逻辑
  useEffect(() => {
    if (level < DISTRICT_LEVEL || isShowClusterMarkerOfDistrict) {
      clearPoint();
      clearPolygon();
    }
  }, [level, isShowClusterMarkerOfDistrict]);


  useEffect(() => {
    polygonListRef.current?.forEach((polygon) => {
      polygon.setOptions({
        fillOpacity: isSatellite ? 0.4 : 0.2,
      });
    });
  }, [polygonListRef.current, isSatellite]);

  return <div>
    <MarkerCon
      pointListRef={pointListRef}
      newPointData={newPointData}
      allPolygonData={polygonData}
      newPolygonData={newPolygonData}
      mapIns={mapIns}
      curSelectRef={curSelectRef}
      hasClickRef={hasClickRef}
      isShapeRef={isShapeRef}
      allPointDataRef={allPointDataRef}
      setItemData={setItemData}
      polygonListRef={polygonListRef}
      itemData={itemData}
      locationInfo={locationInfo}
      allPointData={allPointData}
      targetZoomNamesMarkerRef={targetZoomNamesMarkerRef}
      curZoom={curZoom}
      viewAreaData={viewAreaData}
      isBatchCollect={isBatchCollect}
      batchCollectIds={batchCollectIds}
      setBatchCollectIds={setBatchCollectIds}
      cityProvinceInfo={cityProvinceInfo}
    />
  </div>;
};
export default Point;
